import { useEffect, useState } from 'react';
import { useFormContext } from 'react-hook-form';
import { Element } from 'react-scroll';

import styles from '@components/join/join.module.scss';
import LabelInput from '@components/labelInput';
import { onInputPassword, rePasswordValidator, valueRequired } from '@utils/validators/validators';
import { GUIDE_TEXT, SUCCESS_TEXT } from '@utils/validators/text';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface IRePassword {
  prefixName: string;
}

const RePassword = ({ prefixName }: IRePassword) => {
  const {
    watch,
    register,
    formState: { errors },
    clearErrors,
  } = useFormContext();
  const [isRePwVisible, setIsRePwVisible] = useState(false);

  const rePassword = watch(prefixName);
  const password = watch('password');
  const samePassword = password && rePassword && password === rePassword;
  const onChangeIsRePwVisible = () => {
    setIsRePwVisible(!isRePwVisible);
  };

  /* rePassword를 그대로두고 password를 변경하여 비밀번호를 일치시키면
    rePassword의 validate는 동작하지 않기 때문에, clearError필요함.
  */
  useEffect(() => {
    if (samePassword) clearErrors('rePassword');
  }, [samePassword]);

  return (
    <Element name={prefixName} className={cx('infoWrap', 'type2')}>
      <LabelInput
        {...register(prefixName, {
          ...valueRequired,
          validate: (value: string) => rePasswordValidator(value, password),
        })}
        type={isRePwVisible ? 'text' : 'password'}
        minLength={6}
        maxLength={16}
        onInput={onInputPassword}
        className={cx('input', { error: errors.rePassword, success: samePassword })}
        placeholder="비밀번호 재확인"
        isvalue={rePassword}
        tabIndex={7}
      />
      {samePassword && <div className={cx('infoText', 'success')}>{SUCCESS_TEXT.RE_PASSWORD}</div>}
      {errors.rePassword && !samePassword && (
        <div className={cx('infoText', 'error')}>{errors.rePassword.message as string}</div>
      )}
      <div className={cx('infoText')}>{GUIDE_TEXT.PASSWORD}</div>
      <span className={cx('btnArea')}>
        <button
          tabIndex={-1}
          type="button"
          className={cx('btnConfirmPassword', { on: isRePwVisible })}
          onClick={onChangeIsRePwVisible}
        />
      </span>
    </Element>
  );
};

export default RePassword;
